import { useParams } from 'react-router';

import { useFullPerson, useProperty } from '~/client/hooks/storeHooks';

export const usePersonFromPath = () => {
  const { propertyId: propertyIdParam, personId: personIdParam } = useParams();
  const propertyId = parseInt(propertyIdParam!);
  const personId = parseInt(personIdParam!);

  const property = useProperty(propertyId);
  const person = useFullPerson(personId);

  return { property, person };
};
